import * as React from "react";
import Svg from "./StyledSvg";
type Props = {
  size?: "XS" | "S" | "M" | "L" | "XL" | "XXL";
  color?: string;
  style?: object;
};

interface SizeData {
    size: number;
    stroke: number;
  }

  interface AvailableSizes {
    XS: SizeData;
    S: SizeData;
    M: SizeData;
    L: SizeData;
    XL: SizeData;
    XXL: SizeData;
  }
  ;
const availableSizes: AvailableSizes = {"XS":{"size":16,"stroke":1.3},"S":{"size":20,"stroke":1.5},"M":{"size":24,"stroke":1.8},"L":{"size":40,"stroke":2.2},"XL":{"size":48,"stroke":2.5},"XXL":{"size":70,"stroke":2.8}};
function SettingsAlt({
  size = "M",
  color = "currentColor",
  style
}: Props): React.JSX.Element {
  const strokeWidth = availableSizes[size]?.stroke;
  const appliedSize = availableSizes[size]?.size;
  return <Svg width={appliedSize} height={appliedSize} viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg" color={color} style={style}><path vectorEffect="non-scaling-stroke" d="M18 4.99998H21M3 4.99998H11M13 12H21M3 12H6M18 19H21M3 19H11M17.414 3.57998C18.194 4.35998 18.194 5.61998 17.414 6.39998C16.624 7.17998 15.364 7.17998 14.584 6.39998C13.794 5.60998 13.794 4.34998 14.584 3.56998C15.364 2.77998 16.624 2.77998 17.404 3.56998M9.41 10.586C10.19 11.366 10.19 12.626 9.41 13.406C8.62 14.186 7.36 14.186 6.58 13.406C5.79 12.616 5.79 11.356 6.58 10.576C7.36 9.78598 8.62 9.78598 9.4 10.576M17.414 17.586C18.194 18.366 18.194 19.626 17.414 20.406C16.624 21.186 15.364 21.186 14.584 20.406C13.794 19.616 13.794 18.356 14.584 17.576C15.364 16.786 16.624 16.786 17.404 17.576" stroke="currentColor" strokeWidth={strokeWidth} strokeLinecap="round" strokeLinejoin="round" /></Svg>;
}
export default SettingsAlt;